<template>
  <div class="partner_list_wrap">
    <div class="partner_list flex flex_wrap">
      <div
        class="partner_img flex flex_content_center flex_items_center"
        v-for="(item, index) in list"
        :key="index"
        @click="toLink(item.url)"
      >
        <img :src="item.img" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    toLink(path) {
      if (path) {
        window.open(path, "_blank");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.partner_list_wrap {
  padding: 30px 0 120px;
  .partner_list {
    .partner_img {
      width: 158px;
      height: 70px;
      cursor: pointer;
      margin-right: 26px;
      margin-bottom: 20px;
      background: #fff;
      border: 1px solid rgba(6, 63, 151, 0.08);
      &:nth-child(7n) {
        margin-right: 0;
      }
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
}
@media only screen and (max-width: 1280px) {
  .partner_list_wrap {
    .partner_list {
      .partner_img {
        width: calc((100% - 100px) / 7);
        height: 66px;
        margin-right: 14px;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .partner_list_wrap {
    margin: 20px 0 30px;
    padding: 20px 0 50px;
    background: #fff url("../assets/imgs/p_bg.png") no-repeat center -50px;
    background-size: 100% 120%;
    .partner_list {
      .partner_img {
        width: 1.44rem;
        height: 0.77rem;
        margin-right: 0.2rem;
        margin-bottom: 0.19rem;
        &:nth-child(4n) {
          margin-right: 0;
        }
        &:nth-child(7n) {
          margin-right: 0.2rem;
        }
      }
    }
  }
}
</style>